import React from 'react';
import { useT } from '../i18n/LanguageContext';

export default function IconButton({ icon, onClick, className = '', title }) {
  const t = useT();
  return (
    <button
      onClick={onClick}
      title={t(title)}
      className={`w-[46px] h-[46px] border border-[#e2e8f0] rounded-[10px] shadow-sm bg-white flex items-center justify-center hover:bg-gray-50 transition-colors ${className}`}
    >
      <span className="material-symbols-outlined text-[#64748b] text-[20px]">{icon}</span>
    </button>
  );
}
